module.exports = __webpack_public_path__ + "static/media/snowflake.4164c097.svg";